import { render } from "./EventCard.vue?vue&type=template&id=2bca1e35"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=2bca1e35&lang=css"

import exportComponent from "/Users/morris.lin/Self/project/vue-rick-and-morty/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__